import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PhotoPlaceholder from '../components/photo-placeholder';
import Testimonials from '../components/testimonials';
import { CATS } from '../data/services';
import { PROMOS } from '../data/promotions';
import { TRABAJOS, SELLOS, MES_ACTUAL } from '../data/content';
import { BUSINESS, telLink } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';
import { eyebrow, pillButtonPrimary, pillButtonSecondary } from '../lib/styles';

const waLink = buildWhatsappUrl(BUSINESS.whatsapp, 'Hola Zenya, me gustaría agendar una cita.');

const Home = () => (
  <div>
    {/* Hero */}
    <section
      style={{
        padding: '6vw 5vw',
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '4vw',
        alignItems: 'center',
        maxWidth: 1240,
        margin: '0 auto',
      }}
      className="z-hero-grid"
    >
      <div style={{ animation: 'zRise 500ms var(--ease-out)' }}>
        <span style={eyebrow}>Nails &amp; Spa · Puebla</span>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 300,
            fontSize: 'clamp(38px, 7.2vw, 74px)',
            lineHeight: 1.04,
            color: 'var(--ink-900)',
            margin: '16px 0 0',
            letterSpacing: '-.01em',
          }}
        >
          Un momento
          <br />
          <em style={{ fontStyle: 'italic', color: 'var(--rose-700)' }}>para ti</em>
        </h1>
        <p
          style={{
            fontSize: 'clamp(15px, 1.55vw, 18px)',
            lineHeight: 1.7,
            color: 'var(--ink-600)',
            maxWidth: '44ch',
            margin: '20px 0 0',
          }}
        >
          Manicure, pestañas, faciales y masaje en un espacio tranquilo, limpio y hecho para que salgas sintiéndote
          distinta. Cuidamos el detalle y tu tiempo.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 30 }}>
          <Link to="/servicios" style={pillButtonPrimary}>
            Ver servicios
            <ArrowRight size={16} strokeWidth={1.7} />
          </Link>
          <Link to="/agendar" style={pillButtonSecondary}>
            Agendar cita
          </Link>
        </div>
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 9,
            marginTop: 16,
            fontSize: 14,
            color: 'var(--ink-600)',
          }}
        >
          <span style={{ borderBottom: '1px solid var(--ink-300)' }}>¿Tienes dudas? Escríbenos por WhatsApp</span>
        </a>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 22,
            marginTop: 38,
            paddingTop: 24,
            borderTop: '1px solid var(--ink-200)',
          }}
        >
          {[
            ['4', 'Áreas de servicio'],
            ['Cita', 'Sin esperas'],
            ['100%', 'Material esterilizado'],
          ].map(([num, label]) => (
            <div key={label}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 28, color: 'var(--ink-900)', lineHeight: 1 }}>
                {num}
              </div>
              <div
                style={{
                  fontSize: 11,
                  letterSpacing: '.14em',
                  textTransform: 'uppercase',
                  color: 'var(--ink-500)',
                  marginTop: 4,
                }}
              >
                {label}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        <PhotoPlaceholder
          label="Manos con manicure terminado · vertical"
          style={{ gridRow: 'span 2', height: '100%' }}
        />
        <PhotoPlaceholder label="Interior del salón" tone="lavender" />
        <PhotoPlaceholder label="Detalle de pestañas" />
      </div>
    </section>

    {/* Trust bar */}
    <section
      style={{
        background: '#FFF',
        borderTop: '1px solid var(--ink-100)',
        borderBottom: '1px solid var(--ink-100)',
        padding: '22px 5vw',
      }}
    >
      <div
        style={{
          maxWidth: 1240,
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '14px 40px',
          justifyContent: 'center',
        }}
      >
        {SELLOS.map((s) => (
          <span
            key={s}
            style={{ fontSize: 11.5, letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--ink-500)' }}
          >
            {s}
          </span>
        ))}
      </div>
    </section>

    {/* Categorías */}
    <section style={{ padding: '6vw 5vw', maxWidth: 1240, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', maxWidth: '60ch', margin: '0 auto 4vw' }}>
        <span style={eyebrow}>Servicios</span>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 300,
            fontSize: 'clamp(30px, 4.4vw, 50px)',
            lineHeight: 1.1,
            color: 'var(--ink-900)',
            margin: '14px 0 12px',
          }}
        >
          Cuatro formas de cuidarte
        </h2>
        <p style={{ fontSize: 15.5, lineHeight: 1.7, color: 'var(--ink-600)', margin: 0 }}>
          Cada área tiene su propio espacio, su equipo y su ritmo. Elige por donde quieras empezar.
        </p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))', gap: 22 }}>
        {CATS.map((c) => (
          <article
            key={c.id}
            style={{
              background: '#FFF',
              border: '1px solid var(--ink-200)',
              borderRadius: 'var(--radius-xl)',
              boxShadow: 'var(--shadow-md)',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <PhotoPlaceholder
              label={c.nombre}
              nota={`${c.slides.length} fotos en rotación`}
              ratio="4/3"
              style={{ borderRadius: 0, border: 'none', borderBottom: '1px dashed var(--rose-200)' }}
            />
            <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 12, flex: 1 }}>
              <h3
                style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 400,
                  fontSize: 27,
                  color: 'var(--ink-900)',
                  margin: 0,
                }}
              >
                {c.nombre}
              </h3>
              <p style={{ fontSize: 14.5, lineHeight: 1.65, color: 'var(--ink-600)', margin: 0, flex: 1 }}>{c.desc}</p>
              <Link
                to={`/servicios/${c.id}`}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8,
                  color: 'var(--rose-700)',
                  fontSize: 13.5,
                  letterSpacing: '.08em',
                  textTransform: 'uppercase',
                  marginTop: 4,
                }}
              >
                {c.cta}
                <ArrowRight size={15} strokeWidth={1.7} />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>

    {/* Instalaciones split */}
    <section style={{ background: '#FFF', borderTop: '1px solid var(--ink-100)', padding: '6vw 5vw' }}>
      <div
        style={{
          maxWidth: 1240,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '4vw',
          alignItems: 'center',
        }}
        className="z-split-grid"
      >
        <div>
          <span style={eyebrow}>Instalaciones</span>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 'clamp(28px, 4.2vw, 46px)',
              lineHeight: 1.12,
              color: 'var(--ink-900)',
              margin: '14px 0 16px',
            }}
          >
            El lugar importa tanto
            <br />
            como el servicio
          </h2>
          <p
            style={{ fontSize: 15.5, lineHeight: 1.75, color: 'var(--ink-600)', margin: '0 0 26px', maxWidth: '46ch' }}
          >
            Luz suave, música baja y un espacio ordenado. Queremos que en cuanto cruces la puerta sepas exactamente
            dónde estás y puedas soltar el día.
          </p>
          <Link
            to="/instalaciones"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              color: 'var(--rose-700)',
              fontSize: 13.5,
              letterSpacing: '.08em',
              textTransform: 'uppercase',
            }}
          >
            Conoce el espacio
            <ArrowRight size={15} strokeWidth={1.7} />
          </Link>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          {['Recepción', 'Estaciones de manicure', 'Cabina de masaje', 'Área de pestañas'].map((label) => (
            <PhotoPlaceholder key={label} label={label} />
          ))}
        </div>
      </div>
    </section>

    {/* Nuestros trabajos preview */}
    <section style={{ padding: '6vw 5vw', maxWidth: 1240, margin: '0 auto' }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 16,
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          marginBottom: '3vw',
        }}
      >
        <div>
          <span style={eyebrow}>Nuestros trabajos</span>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 'clamp(28px, 4.2vw, 46px)',
              lineHeight: 1.12,
              color: 'var(--ink-900)',
              margin: '14px 0 0',
            }}
          >
            Diseños reales de clientas reales
          </h2>
        </div>
        <Link
          to="/nuestros-trabajos"
          style={{ color: 'var(--rose-700)', fontSize: 13.5, letterSpacing: '.08em', textTransform: 'uppercase' }}
        >
          Ver galería completa
        </Link>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 190px), 1fr))', gap: 14 }}>
        {TRABAJOS.slice(0, 5).map((t) => (
          <PhotoPlaceholder key={t.label} label={t.label} ratio={t.ratio} />
        ))}
      </div>
    </section>

    {/* Promociones */}
    <section style={{ background: 'var(--rose-50)', padding: '6vw 5vw' }}>
      <div style={{ maxWidth: 1240, margin: '0 auto' }}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            marginBottom: '3vw',
          }}
        >
          <div>
            <span style={eyebrow}>Promociones del mes</span>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 300,
                fontSize: 'clamp(28px, 4.2vw, 46px)',
                lineHeight: 1.12,
                color: 'var(--ink-900)',
                margin: '14px 0 0',
              }}
            >
              {MES_ACTUAL}
            </h2>
          </div>
          <Link
            to="/promociones"
            style={{ color: 'var(--rose-700)', fontSize: 13.5, letterSpacing: '.08em', textTransform: 'uppercase' }}
          >
            Ver todas
          </Link>
        </div>
        <div
          style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 260px), 1fr))', gap: 22 }}
        >
          {PROMOS.slice(0, 3).map((p) => (
            <article
              key={p.id}
              style={{
                background: '#FFF',
                border: '1px solid var(--ink-200)',
                borderRadius: 'var(--radius-xl)',
                padding: 26,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 14,
                boxShadow: 'var(--shadow-sm)',
              }}
            >
              <PhotoPlaceholder label={p.foto} shape="circle" style={{ width: 150 }} tone="lavender" />
              <h3
                style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 400,
                  fontSize: 24,
                  color: 'var(--ink-900)',
                  margin: 0,
                }}
              >
                {p.nombre}
              </h3>
              <p style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--ink-600)', margin: 0 }}>{p.desc}</p>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
                <span style={{ fontFamily: 'var(--font-display)', fontSize: 30, color: 'var(--rose-700)' }}>
                  {p.precio}
                </span>
                <span style={{ fontSize: 14, color: 'var(--ink-400)', textDecoration: 'line-through' }}>{p.antes}</span>
              </div>
              <span
                style={{ fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--ink-500)' }}
              >
                {p.vigencia}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>

    {/* Closing CTA */}
    <section style={{ padding: '6vw 5vw', maxWidth: 1240, margin: '0 auto', textAlign: 'center' }}>
      <img
        src="/zenya-mark-rose.png"
        alt=""
        style={{ height: 56, width: 'auto', margin: '0 auto 22px', display: 'block' }}
      />
      <h2
        style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 300,
          fontSize: 'clamp(28px, 4.6vw, 48px)',
          lineHeight: 1.15,
          color: 'var(--ink-900)',
          margin: '0 auto 18px',
          maxWidth: '20ch',
        }}
      >
        ¿Lista para tu próxima cita?
      </h2>
      <p style={{ fontSize: 15.5, lineHeight: 1.7, color: 'var(--ink-600)', maxWidth: '52ch', margin: '0 auto 30px' }}>
        Elige día y hora en línea. Si todavía tienes dudas sobre qué servicio te conviene, escríbenos y lo vemos juntas.
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center' }}>
        <Link to="/agendar" style={{ ...pillButtonPrimary }}>
          Agendar cita
        </Link>
        <a href={waLink} target="_blank" rel="noreferrer" style={pillButtonSecondary}>
          Preguntar por WhatsApp
        </a>
        <a href={telLink} style={{ ...pillButtonSecondary, borderColor: 'var(--ink-200)', color: 'var(--ink-700)' }}>
          Llamar {BUSINESS.telefono}
        </a>
      </div>
    </section>

    <Testimonials />
  </div>
);

export default Home;
